export const bottomOfElement = (el) => {
  const scrollPosition = document.documentElement.scrollTop + window.innerHeight - window.innerHeight * 0.2;

  return scrollPosition >= el.offsetHeight;
};

export const isDesktop = () => {
  return window.innerWidth > 1024;
};